import { useCallback } from "react";
import { ChatServerButton } from "../xapp/ChatServerMessage";
import { useExecuteActionCallback } from "./useExecuteActionCallback";
import { useOpenUrlCallback } from "./useOpenUrlCallback";
import { useSelector } from "react-redux";
import { useChatDispatch } from "../utils/useChatDispatch";
import { ChatState, VisualState } from "../store/ChatState";

export type ButtonCallback = (button: ChatServerButton) => void;

export function useButtonCallback(): ButtonCallback {
    const handleOpenUrl = useOpenUrlCallback();
    const chatDispatch = useChatDispatch();
    const visuals = useSelector<ChatState, VisualState>((state) => state.visuals);
    const executeAction = useExecuteActionCallback();

    return useCallback<ButtonCallback>(button => {
        if (button.actionUrl) {
            handleOpenUrl(button.actionUrl, chatDispatch, visuals);
        } else {
            executeAction(button.label);
        }
    }, [chatDispatch, executeAction, handleOpenUrl, visuals]);
}
